<template>
  <div>
    <!--Stats cards-->
    <div class="row">
      <div class="col-lg-3 col-sm-6" v-for="(stats, index) in statsCards" :key="`stats-${index}`">
        <stats-card>
          <div class="icon-big text-center" :class="`icon-${stats.type}`" slot="header">
            <i :class="stats.icon"></i>
          </div>
          <div class="numbers" slot="content">
            <p>{{stats.title}}</p>
            {{stats.value}}
          </div>
          <div class="stats" slot="footer">
            <div class="row">
              <div class="col-xs-12 comp">
              <h4 class="title"> {{stats.compGrade1}}</h4>
                {{stats.compText1}}
              </div>
            </div>
          </div>
        </stats-card>
      </div>

      <div class="col-lg-3 col-sm-6" v-if="statsCards.length === 0">
        <stats-card>
          <div class="icon-big text-center" :class="`icon-info`" slot="header">
            <i class="ti-ticket"></i>
          </div>
          <div class="numbers" slot="content">
            <p class="category">Sem avaliação</p>        
          </div>
          <div class="stats" slot="footer">
            <div class="row">
              <div class="col-xs-12 comp text-center">
                <h4 class="title">Você não possuí códigos de verificação.</h4>
              </div>
            </div>
          </div>
        </stats-card>
      </div>      
    </div>
  </div>
</template>
<script>
  import StatsCard from 'src/components/UIComponents/Cards/StatsCard.vue'

  export default {
    mounted () {
      this.getAccessCodes()
    },
    components: {
      StatsCard
    },
    data () {
      return {
        accessCodes: [],
        statsCards: []
      }
    },
    methods: {
      getAccessCodes () {
        let url = '/collaborator/my-access-code-evaluations'
        axios.get(url)
        .then((response) => {
          this.accessCodes = response.data
          this.generateCards()
        }).catch((error) => {
          console.log(error)
        })
      },
      generateCards () {
        let statsCards = []
        this.accessCodes.forEach(accessCode => {
          switch (accessCode.evaluation_type_id) {
            case 1:
              statsCards.push({
                type: 'danger',
                icon: 'ti-ticket',
                title: 'Código Verificador',
                value: accessCode.code,
                compText1: 'Apresente este código verificador ao seu gestor imediato para que o mesmo consiga realizar sua Avaliação de Desempenho',
                compGrade1: `${accessCode.name} - Avaliação de Desempenho`
              })
              break
            case 2:
              statsCards.push({
                type: 'success',
                icon: 'ti-ticket',
                title: 'Código Verificador',
                value: accessCode.code,
                compText1: 'Apresente este código verificador ao seu gestor imediato para que o mesmo consiga realizar sua Avaliação de Desempenho "Me Avalie Aí"',
                compGrade1: `${accessCode.name} - Avaliação Me Avalie Aí`
              })
              break
          }
        })

        this.statsCards = statsCards
      }
    }
  }

</script>
<style>
.grade_comp{
  text-align:right;
}
.main-panel > .content {
    padding: 30px 15px 0 15px;
    min-height: calc(100% - 187px);
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Evaluation/Code.vue